import { useEffect } from "react"
import { useDispatch } from "react-redux"
import { useHistory } from "react-router-dom"
import { raiseStashPageState } from "~/actions/pageStash"

export const useStashPageStateWhenTransiteAway = (
  pageStatePath: string,
  pageStateGetter: ()=>any,
  deps: any[],
) => {
  const history = useHistory()
  const dispatch = useDispatch()

  useEffect(() => {
    const unregister = history.listen((loc, action) => {
      // we are here because route is about to transit out from current page
      dispatch(raiseStashPageState(pageStatePath, pageStateGetter()))
    })

    return () => {
      unregister()
    }
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dispatch, history, pageStatePath, ...deps])
}